const spacing = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export { spacing };
